import { Image, Container, Text, Center, Stack, useMantineTheme, useMantineColorScheme } from '@mantine/core';
import image from '../../../assets/images/empty.svg';
import imageLight from '../../../assets/images/empty-light.svg';
import { createStyles } from '@mantine/emotion';

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: 80,
    paddingBottom: 80,
    display:'flex',
    justifyContent:'center'
  },
  emptyImage:{
    width:100,
  }

}));

export function EmptyState({style,showImage=true,caption="There are no records available"}) {
  const { classes } = useStyles();
  const theme = useMantineTheme();
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  
  return (
    <Container className={classes.root} style={style}>
        <Center>
        
        <Stack align={'center'}>
            {showImage?
            <div className={classes.emptyImage}>
            <Image src={colorScheme === 'dark'?image:imageLight} />
            </div>
            :null}
            
            <div>          
            <Text c="dimmed" size="sm" align="center">
                {caption}
            </Text>         
            </div>
        </Stack>
      </Center>
    </Container>
  );
}